export function formatNumber(
    value: number | string | undefined,
    decimals = 2,
    thousandSeparator: '' | ' ' = ''
): string {
    if (value === undefined || value === null) {
        return '';
    }

    if (typeof value === 'string') {
        value = parseNumber(value);
    }

    const parts = value.toFixed(decimals).split('.');
    // TODO: Replace this regex since it's vulnerable to denial of service attacks
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

    return parts.join(',');
}

export function parseNumber(value: string | number | undefined | null): number {
    if (typeof value === 'number') {
        return value;
    }

    if (value === undefined || value === null || typeof value !== 'string') {
        return Number.NaN;
    }

    return Number(value.replace(/\s*/, '').replace(',', '.'));
}
